import React from 'react'
import { AccountCircle } from '@material-ui/icons'
import {
  AppBar as Bar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Typography
} from '@material-ui/core'
import clsx from 'clsx'
import { ReactComponent as CompsLogo } from '@src/assets/berkadia-comps-logo.svg'
import PropTypes from 'prop-types'
import useStyles from './Header.style'
import User from '@engine/user'
import { connect } from 'react-redux'
import Comps from '@engine/comps'
import { compose } from 'ramda'
import { withRouter } from 'react-router-dom'
import './Header.scss'
import { ProjectName } from '@components/common'
import { AdvancedSearchInput } from '@components/custom'

function Header({
  children,
  drawerWidth = 0,
  drawerOpened = false,
  currentUser,
  history,
  projectName,
  editFileName,
  isPopupDialogOpen,
  resetflag,
  clearComps,
  searchProjects,
  getAllProjects,
  setPagination,
  loading,
  setTotalProjectsText,
  getRecentProjects,
  setRecentPagination
}) {
  const classes = useStyles({ drawerWidth })
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleMenu = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const saveDialogHandler = () => {
    if (history.location.pathname !== '/comps') {
      if (history.location.pathname.split('/')[2] === undefined) {
        isPopupDialogOpen({ isDialogOpen: true, dialogType: 'save' })
      } else if (history.location.pathname.split('/')[2] !== undefined && resetflag) {
        isPopupDialogOpen({ isDialogOpen: true, dialogType: 'save' })
      } else {
        clearComps()
        history.push('/comps')
      }
    }
  }

  return (
    <Bar
      elevation={1}
      position="sticky"
      data-testid="header"
      className={clsx(classes.bar, drawerOpened && classes.barShift)}
    >
      <Toolbar className={classes.root}>
        <div className="homePageLink" data-testid="comps-logo-div" id="logo-long-div" onClick={saveDialogHandler}>
          <CompsLogo data-testid="logo-long" className={classes.logoLong} />
        </div>
        <div className={classes.children}>{children}
          {history && history.location &&
            history.location.pathname.includes('/preview') ?
            <ProjectName projectName={projectName} editFileName={editFileName} isLoading={loading} />
            : <AdvancedSearchInput getRecentProjects={getRecentProjects} searchProjects={searchProjects} getAllProjects={getAllProjects} setRecentPagination={setRecentPagination} setPagination={setPagination} setTotalProjectsText={setTotalProjectsText} />
          }
        </div>
        <div className="logged-in-user-text">
          <div className="welcome-text">
            <Typography variant="h6">Welcome, {currentUser.firstName}</Typography>
          </div>
          {!currentUser.thumbnailPhoto ?
            <div className="header__user-icon-container" data-testid="profile-icon">
              <IconButton
                aria-label="account of current user"
                aria-controls="simple-user-menu"
                aria-haspopup="true"
                onClick={handleMenu}
                disabled={false}
                color="inherit"
                edge="end"
                data-testid="profile-btn"
              >
                <AccountCircle fontSize="large" className="userIcon-container" />
              </IconButton>
            </div> :
            <div className="header__user-photo-container" data-testid="profile-pic">
              <img
                className="header__user-photo"
                src={
                  currentUser.thumbnailPhoto ||
                  '/images/sL_UserSettings_DefaultAvatar.svg'
                }
                onClick={handleMenu}
              />
            </div>}
        </div>
        <Menu
          id="simple-user-menu"
          elevation={1}
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClose}
          data-testid="user-menu"
          getContentAnchorEl={null}
          PopoverClasses={{ paper: classes.menu }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem divider className={classes.headingMenu} data-testid="first-name">
            <div>
              <Typography variant="h6">{currentUser.firstName} {currentUser.lastName}</Typography>
              <Typography variant="subtitle2" color="textSecondary">
                {currentUser.email}
              </Typography>
            </div>
          </MenuItem>
        </Menu>
      </Toolbar>
    </Bar>
  )
}

Header.propTypes = {
  shortLogo: PropTypes.bool,
  drawerOpened: PropTypes.bool,
  drawerWidth: PropTypes.number,
  currentUser: PropTypes.object,
  children: PropTypes.node,
  projectName: PropTypes.string,
  editFileName: PropTypes.func,
  isPopupDialogOpen: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  resetflag: PropTypes.bool,
  clearComps: PropTypes.func,
  searchProjects: PropTypes.func,
  getAllProjects: PropTypes.func,
  getRecentProjects: PropTypes.func,
  setPagination: PropTypes.func,
  setRecentPagination: PropTypes.func,
  loading: PropTypes.bool,
  setTotalProjectsText: PropTypes.func
}

const mapStateToProps = state => ({
  currentUser: {
    firstName: User.selectors.user.firstName(state),
    lastName: User.selectors.user.lastName(state),
    email: User.selectors.user.email(state),
    thumbnailPhoto: User.selectors.user.thumbnailPhoto(state)
  },
  projectName: Comps.selectors.comps.projectName(state),
  loading: Comps.selectors.network.isLoading(
    state,
    Comps.constants.GET_PROJECT_BY_ID.ACTION
  ),
  resetflag: Comps.selectors.comps.resetflag(state)
})

const mapDispatchToProps = {
  editFileName: Comps.actions.editFileName,
  isPopupDialogOpen: Comps.actions.isPopupDialogOpen,
  clearComps: Comps.actions.clearComps,
  searchProjects: Comps.actions.searchProjects,
  getAllProjects: Comps.actions.getAllProjects,
  setPagination: Comps.actions.setPagination,
  setRecentPagination: Comps.actions.setRecentPagination,
  setTotalProjectsText: Comps.actions.setTotalProjectsText,
  getRecentProjects: Comps.actions.getRecentProjects
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Header)
